import { render, staticRenderFns } from "./CreativeShow.vue?vue&type=template&id=9f20ede2&"
import script from "./CreativeShow.vue?vue&type=script&lang=js&"
export * from "./CreativeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports